import { InteractionStatus } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../constants";
import React from "react";

export const LoginButton = React.memo(() => {
	const { instance, inProgress } = useMsal();

	const handleLogin = async () => {
		if (inProgress === InteractionStatus.None) {
			try {
				await instance.loginRedirect(loginRequest);
			} catch (error) {
				console.info("LoginButton handleLogin loginRedirect error");
				console.error(error);
			}
		} else {
			console.info(
				"LoginButton handleLogin Another interaction is in progress."
			);
		}
	};

	return (
		<>
			<div className="ch-show-lg">
				<div className="flex justify-between ch-border-bottom w-full py-6 px-12">
					<div className="flex gap-6">
						<img
							src="images/svg/cornerstone.svg"
							width="48"
							height="48"
							alt="Cornerstone Health"
						/>
						<div className="ch-title">Cornerstone Admin</div>
					</div>
					<button
						className="ch-button ch-button-primary"
						type="button"
						onClick={handleLogin}
					>
						Login
					</button>
				</div>
			</div>

			<div className="ch-show-md">
				<div className="flex justify-between ch-border-bottom w-full py-4 px-8">
					<div className="flex gap-4">
						<img
							src="images/svg/cornerstone.svg"
							width="48"
							height="48"
							alt="Cornerstone Health"
						/>
						<div className="ch-title">Cornerstone Admin</div>
					</div>
					<button
						className="ch-button ch-button-primary"
						type="button"
						onClick={handleLogin}
					>
						Login
					</button>
				</div>
			</div>
		</>
	);
});
